import { useQuery } from '@apollo/client'
import gql from 'graphql-tag'

import {
  ArtistStoreCollectionBoxFragmentDoc,
  StoreCollectionsSelectQuery,
  StoreCollectionsSelectQueryVariables,
} from '@/clients/utoniq-core/schema'
import { config } from '@/config'
import { useRouter } from '@/core'
import { makeViewModel } from '@/core/architecture'
import { useCurrentUser } from '@/core/auth'

import { Action, State } from './template'

/**
 *
 */
export const useViewModel = makeViewModel<State, Action>(() => {
  const { user } = useCurrentUser()
  const { router } = useRouter<{ artistId: string }>()
  const artistId =
    (config.applicationType === 'standalone'
      ? config.artistId
      : router.query.artistId) ?? '#'

  const { data, loading, fetchMore } = useQuery<
    StoreCollectionsSelectQuery,
    StoreCollectionsSelectQueryVariables
  >(QUERY, {
    variables: { artistId },
    notifyOnNetworkStatusChange: true,
  })

  return {
    state: {
      loading,
      artistId: user?.uid ?? '',
      hasNextPage: !!data?.storeCollections?.pageInfo.hasNextPage,
      collections: data?.storeCollections ?? null,
      isLoggedIn: !!user?.uid,
      point: data?.prepaidPointBalance.formattedPrepaidPointBarance ?? '0',
    },
    actions: {
      async onFetchMore() {
        await fetchMore({
          variables: {
            artistId,
            pageInput: {
              cursor: data?.storeCollections?.pageInfo.endCursor,
            },
          },
        })
      },
    },
  }
})

const QUERY = gql`
  query StoreCollectionsSelect($artistId: String!, $pageInput: PageInput) {
    prepaidPointBalance {
      balance
      prepaidPointId
      formattedPrepaidPointBarance @client
    }
    storeCollections(artistId: $artistId, pageInput: $pageInput) {
      edges {
        node {
          ... on Collection {
            ...ArtistStoreCollectionBox
          }
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
  ${ArtistStoreCollectionBoxFragmentDoc}
`
